import { usePageSEO } from '@/hooks/usePageSEO';
import Header from '@/components/feature/Header';
import Footer from '@/components/feature/Footer';
import Hero from './components/Hero';
import PourquoiLaTole from './components/PourquoiLaTole';
import TypesTole from './components/TypesTole';
import PrixTole from './components/PrixTole';
import ProcessTole from './components/ProcessTole';
import Couleurs from './components/Couleurs';
import Temoignage from './components/Temoignage';
import FAQ from './components/FAQ';
import QuoteForm from './components/QuoteForm';
import CTAFinal from './components/CTAFinal';

const breadcrumbSchema = {
  '@context': 'https://schema.org',
  '@type': 'BreadcrumbList',
  itemListElement: [
    { '@type': 'ListItem', position: 1, name: 'Accueil', item: 'https://couvreur-levis.com/' },
    { '@type': 'ListItem', position: 2, name: 'Toiture tôle métal', item: 'https://couvreur-levis.com/toiture-tole-metal' },
  ],
};

const serviceSchema = {
  '@context': 'https://schema.org',
  '@type': 'Service',
  serviceType: 'Toiture en tôle',
  provider: { '@type': 'LocalBusiness', '@id': 'https://couvreur-levis.com/#business' },
  areaServed: { '@type': 'City', name: 'Lévis' },
  description: "Installation de toiture en tôle à Lévis. Acier galvanisé, joint debout, ferblanterie. Durée de vie 50 ans+.",
  offers: {
    '@type': 'AggregateOffer',
    priceCurrency: 'CAD',
    lowPrice: '14000',
    highPrice: '85000',
    offerCount: '4',
  },
};

const faqSchema = {
  '@context': 'https://schema.org',
  '@type': 'FAQPage',
  mainEntity: [
    {
      '@type': 'Question',
      name: 'La tôle fait-elle vraiment du bruit quand il pleut ?',
      acceptedAnswer: {
        '@type': 'Answer',
        text: "Avec une installation professionnelle et un isolant rigide en polyiso sous la tôle, le bruit de la pluie est comparable à une toiture en bardeau. Le mythe du bruit vient des vieilles toitures tôle posées sans isolant. Nos clients nous disent qu'ils ne remarquent pas de différence.",
      },
    },
    {
      '@type': 'Question',
      name: "Peut-on installer la tôle par-dessus l'ancienne toiture ?",
      acceptedAnswer: {
        '@type': 'Answer',
        text: "Oui, dans certains cas. Si le pontage est sain et que la structure supporte le poids supplémentaire, on peut installer la tôle directement par-dessus le bardeau existant avec des contre-lattes. Ça réduit le coût et le temps. On évalue la structure lors de l'inspection gratuite.",
      },
    },
    {
      '@type': 'Question',
      name: 'Quelle garantie offrez-vous sur une toiture tôle ?',
      acceptedAnswer: {
        '@type': 'Answer',
        text: "Garantie écrite de 15 ans sur la main-d'œuvre et l'étanchéité. De plus, les fabricants (Ideal Roofing, Vicwest, Canam) offrent une garantie fabricant de 35 à 50 ans contre la perforation et la décoloration. Vous avez donc une double protection.",
      },
    },
    {
      '@type': 'Question',
      name: "La tôle est-elle plus chère qu'une réfection en bardeau ?",
      acceptedAnswer: {
        '@type': 'Answer',
        text: "À l'achat, oui. Une toiture tôle coûte 1.5 à 2× plus cher qu'un bardeau d'asphalte. Mais sur la durée de vie, elle est moins chère : un bardeau doit être refait 2-3 fois pendant que la tôle tient 50 ans. Ajoutez la valeur de revente (+5-7%) et les économies d'énergie, et l'investissement devient très rentable.",
      },
    },
    {
      '@type': 'Question',
      name: "Combien de temps prend l'installation complète ?",
      acceptedAnswer: {
        '@type': 'Answer',
        text: 'Un bungalow standard : 3 à 5 jours. Une maison de 2 étages ou un toit complexe : 5 à 8 jours. Le joint debout prend plus de temps car chaque pan est ajusté manuellement. On vous donne un calendrier précis dans la soumission.',
      },
    },
  ],
};

export default function ToleMetalPage() {
  usePageSEO({
    title: 'Toiture en tôle Lévis | Acier, Aluminium, Joint debout',
    description: 'Toiture en tôle à Lévis. Acier galvanisé, joint debout, durée de vie 50 ans+. Soumission gratuite. Appelez le 418-476-9950.',
    urlPath: '/toiture-tole-metal',
    keywords: 'toiture tôle Lévis, toiture métal, acier galvanisé, joint debout, toiture résidentielle, couvreur',
    ogImage: '/og/og-toiture-tole-metal.jpg',
    ogImageAlt: 'Toiture en tôle à Lévis - Durée de vie 50 ans+',
    jsonLdSchema: [breadcrumbSchema, serviceSchema, faqSchema],
  });

  return (
    <div className="font-inter min-h-screen bg-white">
      <Header />
      <main>
        <Hero />
        <PourquoiLaTole />
        <TypesTole />
        <PrixTole />
        <ProcessTole />
        <Couleurs />
        <Temoignage />
        <FAQ />
        <QuoteForm />
        <CTAFinal />
      </main>
      <Footer />
    </div>
  );
}